import { render, staticRenderFns } from "./CategoryFilterModal.vue?vue&type=template&id=077a21e9"
import script from "./CategoryFilterModal.vue?vue&type=script&lang=js"
export * from "./CategoryFilterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports